import React from 'react';
import LanguageContext from '../LanguageContext';

export default function LanguageProvider(props) {
  const { children } = props;
  return <LanguageContext.Provider>{children}</LanguageContext.Provider>;
}
